import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { UserProfilePage } from "globalConstants";
import { getFirstCharacter } from "helpers";
import { userProfileNameSelector } from "store/user/user.reducer";

import Avatar from "./avatar";

import styles from "./userProfileBar.module.scss";

const UserProfileBar = () => {
	const link = `/${UserProfilePage.name}`;

	const userProfile = useSelector(userProfileNameSelector);

	return (
		<div>
			<Link to={link} className={styles.avatarLink}>
				<Avatar
					firstNameCharacter={getFirstCharacter(
						userProfile?.firstName,
					)}
					lastNameCharacter={getFirstCharacter(userProfile?.lastName)}
				/>
			</Link>
		</div>
	);
};

export default UserProfileBar;
